import React, { useEffect } from 'react';
import { Flex, Text, Pane } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TagLowBattery() {
  const {
    setNextText,
    setBackText,
    setHeader
  } = useWizard();
  useEffect(() => {
    // Set the header title using the wizard context
    setHeader('Pair Asset To Tag');
    setNextText('Select Another Tag');
    setBackText('Cancel');
    return () => {
      setNextText(null);
      setBackText(null);
      setHeader(null);
    };
  }, [setNextText, setBackText, setHeader]);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsx("img", {
      src: "https://storage.googleapis.com/recovr-ui-assets/tag-warning.png",
      alt: "Tag warning",
      height: 80,
      width: 80
    }), /*#__PURE__*/_jsx(Text, {
      variant: "formTitle",
      children: "Tag has Low Battery"
    }), /*#__PURE__*/_jsx(Text, {
      children: "This tag's battery is below 50%. You must charge it before pairing it to a key."
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "dashboardCard",
      children: /*#__PURE__*/_jsx(Pane, {
        variant: "dataCard",
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              flexGrow: 1
            },
            children: /*#__PURE__*/_jsx(Text, {
              children: /*#__PURE__*/_jsx("b", {
                children: "Plug the tag into a USBC charger."
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            style: {
              flexGrow: 1
            },
            children: /*#__PURE__*/_jsx(Text, {
              children: "The lights on the sides of the tag should pulse green, confirming that it is charging."
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Text, {
      variant: "link",
      children: /*#__PURE__*/_jsx("a", {
        target: "_blank",
        href: "https://help.equipment.recovr.biz/en/articles/8505499-tag-activation-usage",
        rel: "noreferrer",
        children: "Read the Documentation"
      })
    })]
  });
}

// Add the TYPE property for registration
TagLowBattery.TYPE = 'recovr.TagLowBattery';